var $iih9K$uuid = require("uuid");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "renderCheckout", () => $03899eb4733e0844$export$8977576aacd813d8);



const $461fb312488d387a$export$7d576a40358207c0 = [
    "cvv",
    "expirationDate",
    "cardNumber"
];
var $461fb312488d387a$export$bdb47a4f704771fb = /*#__PURE__*/ function(GlobalPostMessageEventKind) {
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_ERROR"] = "PAYMENT_CARD_FETCH_ERROR";
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_SUCCESS"] = "PAYMENT_CARD_FETCH_SUCCESS";
    // Input/configuration error kind
    GlobalPostMessageEventKind["CARD_VIEWER_INPUT_ERROR"] = "CARD_VIEWER_INPUT_ERROR";
    GlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    GlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    GlobalPostMessageEventKind["TOGGLE_CARD_NUMBER_MASK"] = "TOGGLE_CARD_NUMBER_MASK";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_ERROR"] = "COPY_TO_CLIPBOARD_ERROR";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_SUCCESS"] = "COPY_TO_CLIPBOARD_SUCCESS";
    GlobalPostMessageEventKind["CARD_VIEWER_READY"] = "CARD_VIEWER_READY";
    return GlobalPostMessageEventKind;
}({});


// -- Secure channel handshake protocol (DX-8174 / DX-8205) -------------------
// Shared by every Highnote SDK that delivers credentials to a hosted iframe
// without placing them in the iframe URL (browser history/sync, web archives,
// CDN/proxy logs, analytics scripts reading location.href). The SDK posts
// HANDSHAKE_INIT to the iframe on frame `load` (transferring one MessagePort),
// the iframe replies HANDSHAKE_ACK on that port, and the SDK then delivers
// credentials in a CONFIGURE message over the same private port.
//
// This module lives in @highnoteplatform/types — not @highnoteplatform/iframes —
// deliberately: the published SDKs' parcel builds bundle ONLY this package
// (targets.*.includeNodeModules allowlist, built with --no-scope-hoist, i.e. no
// tree-shaking), so importing the iframes package here would drag its entire
// re-export graph into the public SDK bundles. Do not "tidy" this into iframes.
const $33758c9ec5c9bbe8$export$bdf67dc867af0994 = "SECURE_CHANNEL_HANDSHAKE_INIT";
const $33758c9ec5c9bbe8$export$21b7abb723f51b7e = "SECURE_CHANNEL_HANDSHAKE_ACK";
const $33758c9ec5c9bbe8$export$46fb7dfe3495e1c = "SECURE_CHANNEL_CONFIGURE";
const $33758c9ec5c9bbe8$export$9941bb4ec5193584 = 10000;
const $33758c9ec5c9bbe8$export$ca4bc7545e4f4a8d = 15000;
const $33758c9ec5c9bbe8$export$b5130285aa45b350 = (data, typename)=>typeof data === "object" && data !== null && "__typename" in data && data.__typename === typename;
const $33758c9ec5c9bbe8$export$84683bda827d284f = ({ frame: frame, iframeOrigin: iframeOrigin, uuid: uuid, clientToken: clientToken, paymentCardId: paymentCardId, sdkName: sdkName, sdkVersion: sdkVersion, onFailure: onFailure, onHandshakeAck: onHandshakeAck, timeoutMs: timeoutMs = $33758c9ec5c9bbe8$export$9941bb4ec5193584 })=>{
    let disposed = false;
    let failed = false;
    let cleanupPending;
    // onFailure is one-shot for the channel's lifetime. A frame can emit `load`
    // more than once (reload), and both the FRAME_UNREACHABLE and
    // HANDSHAKE_TIMEOUT paths can be reached again on a subsequent load — the
    // integrator must not be re-notified of the same failed handshake, nor
    // receive a failure after an earlier one already fired.
    const reportFailure = (failure)=>{
        if (failed) return;
        failed = true;
        onFailure(failure);
    };
    const onLoad = ()=>{
        // A reloaded frame is a fresh document with a fresh listener; tear down
        // the previous channel so its timeout cannot fire a spurious error.
        cleanupPending?.();
        cleanupPending = undefined;
        const targetWindow = frame.contentWindow;
        if (targetWindow === null) {
            reportFailure("FRAME_UNREACHABLE");
            return;
        }
        const channel = new MessageChannel();
        const sdkPort = channel.port1;
        const timeout = setTimeout(()=>{
            sdkPort.close();
            cleanupPending = undefined;
            reportFailure("HANDSHAKE_TIMEOUT");
        }, timeoutMs);
        cleanupPending = ()=>{
            clearTimeout(timeout);
            sdkPort.close();
        };
        sdkPort.onmessage = (event)=>{
            if (!$33758c9ec5c9bbe8$export$b5130285aa45b350(event.data, $33758c9ec5c9bbe8$export$21b7abb723f51b7e)) return;
            clearTimeout(timeout);
            onHandshakeAck?.();
            const configure = {
                __typename: $33758c9ec5c9bbe8$export$46fb7dfe3495e1c,
                clientToken: clientToken,
                ...paymentCardId === undefined ? {} : {
                    paymentCardId: paymentCardId
                },
                ...sdkName === undefined ? {} : {
                    sdkName: sdkName
                },
                ...sdkVersion === undefined ? {} : {
                    sdkVersion: sdkVersion
                }
            };
            sdkPort.postMessage(configure);
            // CONFIGURE is the last message on this channel; the iframe closes its
            // end on receipt. Close ours too for lifecycle symmetry — the message
            // is already queued on the peer, so closing here does not drop it.
            // (cleanupPending is left as-is; the disposer's close() is idempotent.)
            sdkPort.close();
        };
        const init = {
            __typename: $33758c9ec5c9bbe8$export$bdf67dc867af0994,
            uuid: uuid
        };
        targetWindow.postMessage(init, iframeOrigin, [
            channel.port2
        ]);
    };
    frame.addEventListener("load", onLoad);
    return ()=>{
        if (disposed) return;
        disposed = true;
        frame.removeEventListener("load", onLoad);
        cleanupPending?.();
        cleanupPending = undefined;
    };
};
const $33758c9ec5c9bbe8$export$d572882ed38b887b = ()=>{
    let settled = false; // one handshake-phase error already surfaced
    let configurePhase = false; // ACK received -> iframe is sole authority
    return {
        ack: ()=>{
            configurePhase = true;
        },
        wrapFailure: (deliver)=>(e)=>{
                if (settled) return;
                settled = true;
                deliver(e);
            },
        wrapRelay: (deliver)=>(e)=>{
                if (configurePhase) {
                    deliver(e); // post-ACK: pass every relayed error unconditionally
                    return;
                }
                if (settled) return; // pre-ACK duplicate: swallow
                settled = true;
                deliver(e);
            }
    };
};


const $b75e2cb0802d3ba7$export$1ec34c2c9b231c0f = [
    "pin",
    "cardNumber",
    "expirationMonth",
    "expirationYear",
    "expirationDate",
    "securityCode"
];
const $b75e2cb0802d3ba7$export$2db53370b14e73a1 = [
    "visa",
    "mastercard",
    "amex",
    "discover"
];
var $b75e2cb0802d3ba7$export$5278e3e6401288b4 = /*#__PURE__*/ function(SecureInputsGlobalPostMessageEventKind) {
    SecureInputsGlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    SecureInputsGlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    SecureInputsGlobalPostMessageEventKind["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    SecureInputsGlobalPostMessageEventKind["REQUEST_ERROR"] = "REQUEST_ERROR";
    SecureInputsGlobalPostMessageEventKind["ON_INPUT"] = "ON_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_SUBMIT"] = "ON_SUBMIT";
    SecureInputsGlobalPostMessageEventKind["CHANGE_CARD_PIN"] = "CHANGE_CARD_PIN";
    SecureInputsGlobalPostMessageEventKind["TOKENIZE_CARD"] = "TOKENIZE_CARD";
    SecureInputsGlobalPostMessageEventKind["ON_CARD_INPUT"] = "ON_CARD_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_PIN_CHANGE_SUCCESS"] = "ON_PIN_CHANGE_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_TOKENIZE_CARD_SUCCESS"] = "ON_TOKENIZE_CARD_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_STATE_CHANGE"] = "ON_STATE_CHANGE";
    SecureInputsGlobalPostMessageEventKind["ON_READY"] = "ON_READY";
    SecureInputsGlobalPostMessageEventKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    return SecureInputsGlobalPostMessageEventKind;
}({});






var $60d64b55775a4585$export$c278f139ce6eedba = /*#__PURE__*/ function(CheckoutPostMessageKind) {
    CheckoutPostMessageKind["TOKENIZE_SUCCCESS"] = "TOKENIZE_SUCCCESS";
    CheckoutPostMessageKind["TOKENIZE_ERROR"] = "TOKENIZE_ERROR";
    CheckoutPostMessageKind["CHECKOUT_READY"] = "CHECKOUT_READY";
    return CheckoutPostMessageKind;
}({});
class $60d64b55775a4585$export$4e94f40711c15818 extends Error {
    constructor(message, errors){
        super(message), this.name = "CheckoutConfigInputError";
        this.errors = errors;
    }
}
const $60d64b55775a4585$export$e65600b7ad68fd67 = [
    "Pay",
    "Submit"
];


// Descriptive SDK identity for the `x-highnote-sdk` adoption-telemetry header
// (`<name>/<version>`). Lives in @highnoteplatform/types because that is the
// only package bundled into every public SDK's parcel build (see
// secureChannel.ts) — the one bundle-safe shared home.
//
// HOW TO INSTRUMENT A NEW SDK
// 1. In the SDK package, import its own package.json name + version:
//        import { name, version } from "../package.json";
// 2. Build the identity so `name` can't drift from the published package name:
//        const SDK = sdkIdentityFromPackage({ name, version });
// 3. Page-context SDK: pass SDK as the 3rd arg to `highnoteClient(...)`, behind a
//    small `xxxClient` factory (see documentUploadClient / riskApplicationClient).
//    Iframe SDK: reuse SDK.name for BOTH the CDN path segment and the
//    secure-channel handshake `sdkName` (see card-viewer/secure-inputs
//    config.ts + handshake.ts) so telemetry and CDN can't desync.
const $58898565a9eaf503$var$SCOPE_PREFIX = /^@highnoteplatform\//;
const $58898565a9eaf503$export$3ddec0068072ba94 = (pkg)=>({
        name: pkg.name.replace($58898565a9eaf503$var$SCOPE_PREFIX, ""),
        version: pkg.version
    });


const $28cf655d42637490$export$8acf5617026d4b16 = [
    "borderRadius",
    "backgroundColor",
    "color",
    "cursor",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "userSelect",
    "border"
];
const $28cf655d42637490$export$93b12edf1b0f1762 = [
    ":focus",
    ":hover",
    ":invalid",
    ":valid"
];
const $28cf655d42637490$export$679b0194e2408a3e = [
    "live",
    "test"
];



var $02420ba1a520e020$exports = {};
$02420ba1a520e020$exports = JSON.parse("{\"name\":\"@highnoteplatform/checkout\",\"version\":\"0.10.1\",\"description\":\"Render Highnote card checkout UI\",\"source\":\"src/index.ts\",\"access\":\"public\",\"main\":\"lib/index.js\",\"module\":\"lib/esm/module.js\",\"types\":\"lib/types.d.ts\",\"files\":[\"lib\",\"README.md\"],\"scripts\":{\"clean\":\"rimraf lib dist\",\"prebuild\":\"npm run clean\",\"build\":\"PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache\",\"postbuild\":\"node ../../scripts/fix-node-env.js\",\"prepublishOnly\":\"npm run build\",\"test\":\"jest\",\"test:watch\":\"jest --watch\",\"prepack\":\"npm run build\",\"predev\":\"node ../../scripts/clean-build-output.js lib dist\",\"dev\":\"parcel watch --port 3016 --hmr-port 2016 --no-cache --dist-dir=lib\"},\"author\":\"packages@highnote.com\",\"license\":\"MIT\",\"homepage\":\"https://highnote.com\",\"devDependencies\":{\"@highnoteplatform/types\":\"*\",\"@types/jest\":\"^28.1.7\",\"@types/uuid\":\"^9.0.1\",\"@types/jsdom\":\"21.1.1\",\"@types/node\":\"^22.0.0\",\"eslint-plugin-jest\":\"27.2.1\",\"jest\":\"^28.1.3\",\"jest-environment-jsdom\":\"^29.5.0\",\"jsdom\":\"^21.1.1\",\"ts-jest\":\"^28.0.8\"},\"targets\":{\"main\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true},\"module\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true}},\"dependencies\":{\"uuid\":\"^11.0.0\"}}");


const { CHECKOUT_IFRAME_PORT: $935e89dc04983067$var$CHECKOUT_IFRAME_PORT = 3014 } = process.env;
const $935e89dc04983067$var$identity = (0, $58898565a9eaf503$export$3ddec0068072ba94)({
    name: $02420ba1a520e020$exports.name,
    version: $02420ba1a520e020$exports.version
});
const $935e89dc04983067$export$9345d7360ffe0722 = $935e89dc04983067$var$identity.name;
const $935e89dc04983067$export$91546b032799aa40 = $935e89dc04983067$var$identity.version;
const $935e89dc04983067$export$f76cea9319723dd2 = process.env.NODE_ENV === "production" ? "https://cdn.highnote.com" : `http://localhost:${$935e89dc04983067$var$CHECKOUT_IFRAME_PORT}`;
// NOTE: the production iframe bundle is fetched from a fixed CDN path segment
// ("checkout") that MUST match the deploy pipeline's hardcoded app name
// (publish-release.yml `matrix.app`) — keep it a literal, never derived, so a
// package.json rename can't point the fetch at an undeployed path. The version
// segment keys the bundle to THIS package's version: a release that changes
// checkout-iframes without bumping @highnoteplatform/checkout would overwrite an
// already-deployed bundle in place — always version them together. The telemetry
// sdkName (handshake.ts) IS derived from the package name via packageName;
// handshake.test.ts asserts sdkName === "checkout", which pins packageName to
// this same literal so the telemetry label and CDN segment cannot silently
// desync.
const $935e89dc04983067$var$iframePath = process.env.NODE_ENV === "production" ? `checkout/${$935e89dc04983067$export$91546b032799aa40}/index.html` : "index.html";
const $935e89dc04983067$export$f7872bdb68630f49 = `${$935e89dc04983067$export$f76cea9319723dd2}/${$935e89dc04983067$var$iframePath}`;


const $2309ea91b00c6127$export$28ca0294113407cf = ({ uuid: uuid, checkoutConfig: checkoutConfig })=>{
    const frame = document.createElement("iframe");
    // The client token is deliberately NOT placed in the URL — it is delivered
    // over the private MessagePort handshake (see ./handshake). Only non-secret
    // configuration travels in the frame src.
    const urlParameters = new URLSearchParams();
    urlParameters.set("environment", checkoutConfig.environment ?? "test");
    if (checkoutConfig.additionalFormSections) urlParameters.set("additionalFormSections", JSON.stringify(checkoutConfig.additionalFormSections));
    if (checkoutConfig.excludedCardBrands) urlParameters.set("excludedCardBrands", checkoutConfig.excludedCardBrands.join("|"));
    if (checkoutConfig.submitButton) urlParameters.set("submitButton", JSON.stringify(checkoutConfig.submitButton));
    const frameSource = new URL(`${(0, $935e89dc04983067$export$f7872bdb68630f49)}?${encodeURIComponent(urlParameters.toString())}`);
    frameSource.hash = uuid;
    frame.setAttribute("src", frameSource.toString());
    frame.setAttribute("allow", "clipboard-write");
    frame.style.setProperty("border", "none");
    return frame;
};




const $3d7df52003e9fd84$var$FAILURE_MESSAGES = {
    FRAME_UNREACHABLE: "Unable to reach the checkout frame. Please try again or contact support.",
    HANDSHAKE_TIMEOUT: "Checkout frame did not respond. Please try again or contact support."
};
const $3d7df52003e9fd84$export$5444edc1b7f4f9ff = ({ frame: frame, uuid: uuid, clientToken: clientToken, onError: onError, onHandshakeAck: onHandshakeAck })=>(0, $33758c9ec5c9bbe8$export$84683bda827d284f)({
        frame: frame,
        iframeOrigin: $935e89dc04983067$export$f76cea9319723dd2,
        uuid: uuid,
        clientToken: clientToken,
        sdkName: (0, $935e89dc04983067$export$9345d7360ffe0722),
        sdkVersion: (0, $935e89dc04983067$export$91546b032799aa40),
        onHandshakeAck: onHandshakeAck,
        onFailure: (failure)=>{
            onError({
                name: "SecureInputsHandshakeError",
                message: $3d7df52003e9fd84$var$FAILURE_MESSAGES[failure]
            });
        }
    });




const $862f63a202ea4b7c$export$b3d7f7f61e4ab05a = (uuid, onTokenizeError, onTokenizeSuccess, onReady)=>(event)=>{
        if (event.origin !== (0, $935e89dc04983067$export$f76cea9319723dd2) || uuid !== event.data.uuid) return false;
        const { data: data } = event.data;
        switch(data.kind){
            case (0, $60d64b55775a4585$export$c278f139ce6eedba).TOKENIZE_SUCCCESS:
                onTokenizeSuccess(data);
                break;
            case (0, $60d64b55775a4585$export$c278f139ce6eedba).TOKENIZE_ERROR:
                onTokenizeError(data.error);
                break;
            case (0, $60d64b55775a4585$export$c278f139ce6eedba).CHECKOUT_READY:
                onReady(data);
                break;
            default:
                break;
        }
        return true;
    };



const $4c7409d0efcccfe8$var$allowedEnvironments = [
    "test",
    "live"
];
const $4c7409d0efcccfe8$export$b8d6bda6b8a0445d = (config)=>{
    const errors = [];
    if (!config.clientToken || typeof config.clientToken !== "string") errors.push({
        message: "clientToken is required and must be a string",
        field: "clientToken"
    });
    if (!config.selector || typeof config.selector !== "string") errors.push({
        message: "selector is required and must be a string",
        field: "selector"
    });
    if (!config.onTokenizeError || typeof config.onTokenizeError !== "function") errors.push({
        message: "onTokenizeError is required and must be a function",
        field: "onTokenizeError"
    });
    if (!config.onTokenizeSuccess || typeof config.onTokenizeSuccess !== "function") errors.push({
        message: "onTokenizeSuccess is required and must be a function",
        field: "onTokenizeSuccess"
    });
    if (config.environment && !$4c7409d0efcccfe8$var$allowedEnvironments.includes(config.environment)) errors.push({
        message: `environment must be one of ${$4c7409d0efcccfe8$var$allowedEnvironments.join(", ")}`,
        field: "environment"
    });
    if (config.submitButton?.text && !(0, $60d64b55775a4585$export$e65600b7ad68fd67).includes(config.submitButton.text)) errors.push({
        message: `submitButton.text must be one of: ${(0, $60d64b55775a4585$export$e65600b7ad68fd67).join(", ")}`,
        field: "submitButton.text"
    });
    if (errors.length > 0) return errors;
    return undefined;
};


function $03899eb4733e0844$export$8977576aacd813d8(config) {
    const errors = (0, $4c7409d0efcccfe8$export$b8d6bda6b8a0445d)(config);
    if (errors) throw new (0, $60d64b55775a4585$export$4e94f40711c15818)("Invalid checkout config", errors);
    return new Promise((resolve)=>{
        const { selector: selector, onTokenizeError: onTokenizeError, onTokenizeSuccess: onTokenizeSuccess } = config;
        const uuid = (0, $iih9K$uuid.v4)();
        const frame = (0, $2309ea91b00c6127$export$28ca0294113407cf)({
            uuid: uuid,
            checkoutConfig: config
        });
        const container = document.querySelector(selector) ?? document.body;
        // Dedupe the parent timeout and the iframe's relayed configure-timeout at
        // their convergence on onTokenizeError (see HandshakeGate). Single frame,
        // one credentialed channel.
        const gate = (0, $33758c9ec5c9bbe8$export$d572882ed38b887b)();
        // Attach the secure-channel load listener BEFORE inserting the frame so no
        // load event is missed. The client token is delivered to the iframe over
        // this private MessagePort, never the URL.
        const disposeSecureChannel = (0, $3d7df52003e9fd84$export$5444edc1b7f4f9ff)({
            frame: frame,
            uuid: uuid,
            clientToken: config.clientToken,
            onError: gate.wrapFailure(onTokenizeError),
            onHandshakeAck: gate.ack
        });
        container.append(frame);
        // eslint-disable-next-line prefer-const
        let handlePostMessage;
        const unmount = ()=>{
            // Tear down the handshake first so no pending timer can call onError
            // after the frame is gone.
            disposeSecureChannel();
            window.removeEventListener("message", handlePostMessage);
            container.replaceChildren("");
        };
        const onReady = ()=>{
            resolve({
                unmount: unmount
            });
        };
        handlePostMessage = (0, $862f63a202ea4b7c$export$b3d7f7f61e4ab05a)(uuid, gate.wrapRelay(onTokenizeError), onTokenizeSuccess, onReady);
        // remove explicit call after postMessage is implemented in iframe
        onReady({
            kind: (0, $60d64b55775a4585$export$c278f139ce6eedba).CHECKOUT_READY
        });
        window.removeEventListener("message", handlePostMessage);
        window.addEventListener("message", handlePostMessage);
    });
}


//# sourceMappingURL=index.js.map
